import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import useForm from '../utils/useForm';

const useBorrowerPropertyForm = (onSubmit, values) => {
  const { t } = useTranslation();

  const fields = useMemo(
    () => [
      {
        title: t('AddOrEditPage.AddOrEditLoan.Sections.Property.Property'),
        isTitleHidden: false,
        fields: [
          {
            title: t('common.forms.labels.Type'),
            name: '_property.type',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Address Line 1'),
            name: '_property.address_line_1',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Address Line 2'),
            name: '_property.address_line_2',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.City'),
            name: '_property.city',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.State'),
            name: '_property.state',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Zip'),
            name: '_property.zip',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.County'),
            name: '_property._county.name',
            type: 'text',
            readOnly: true,
          },
          {
            title: t('common.forms.labels.Flood Zone'),
            name: 'doesntmatter',
            type: 'text',
            format: (vals) => {
              if (!vals?._property?.flood) {
                return t('common.None');
              }

              return vals?._property?.flood_zone_category || '';
            },
            readOnly: true,
          },
          /* {
            title: t('common.forms.labels.Land value'),
            name: 'land_value',
            type: 'currency',
            readOnly: true,
          }, */
        ],
      },
    ],
    [t]
  );

  return useForm({ fields, onSubmit, values });
};

export default useBorrowerPropertyForm;
